import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import MerchantLandingPage from "../../components/LandingPage/LandingPage";

const LandingPage: FC = () => {
  return <MerchantLandingPage />;
};

export default LandingPage;
